export const BrandedTypeSymbol = Symbol("BrandedType");
export type BrandedTypeSymbol = typeof BrandedTypeSymbol;
export const OriginalTypeSymbol = Symbol("OriginalTypeSymbol");
export type OriginalTypeSymbol = typeof OriginalTypeSymbol;

export type BrandedType<
  T,
  TBranding,
> = T & {
  [ BrandedTypeSymbol ]: TBranding;
  [ OriginalTypeSymbol ]: T;
};

export type AnyBrandedType = BrandedType<unknown, any>;


export type BrandedTypeOrigType<TBranded extends AnyBrandedType> =
  TBranded[ OriginalTypeSymbol ];

export type CreateBrandedTypeFn<TBranded extends AnyBrandedType> = (value: BrandedTypeOrigType<TBranded>) => TBranded;
export type BrandedTypeTypeGuard<TBranded extends AnyBrandedType> =
  ((value: BrandedTypeOrigType<TBranded>) => value is TBranded);

export type BrandedTypeValidationFn<TBranded extends AnyBrandedType> = ((value: BrandedTypeOrigType<TBranded>) => boolean);


export const CastToType_TargetType_Symbol = Symbol("CastToType_TargetType_Symbol");
export type CastToType_TargetType_Symbol = typeof CastToType_TargetType_Symbol;

export const CastToType_OriginalType_Symbol = Symbol("CastToType_OriginalType_Symbol");
export type CastToType_OriginalType_Symbol = typeof CastToType_OriginalType_Symbol;

export const CastToType_AdditionalInfo_Symbol = Symbol("CastToType_AdditionalInfo_Symbol");
export type CastToType_AdditionalInfo_Symbol = typeof CastToType_AdditionalInfo_Symbol;

export type CastToType<
  TOriginalType,
  TTargetType extends {},
  AdditionalInfo = "none"
> = TTargetType & {
  [ CastToType_TargetType_Symbol ]: TTargetType,
  [ CastToType_OriginalType_Symbol ]: TOriginalType,
  [ CastToType_AdditionalInfo_Symbol ]: AdditionalInfo
};


export function isBrandedType<TBranded extends AnyBrandedType> (value: BrandedTypeOrigType<TBranded>, validateFn: BrandedTypeTypeGuard<TBranded>): value is TBranded {
  return validateFn(value);
}